var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_5059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "#0F5EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4466 21.4688L28.4466 13.9688C28.3905 13.8301 28.2942 13.7113 28.17 13.6278C28.0459 13.5442 27.8996 13.4997 27.75 13.5C27.6954 13.5008 27.641 13.5074 27.5878 13.5197L21.75 14.8125V12.75C21.75 12.5511 21.671 12.3603 21.5303 12.2197C21.3897 12.079 21.1989 12 21 12C20.8011 12 20.6103 12.079 20.4697 12.2197C20.329 12.3603 20.25 12.5511 20.25 12.75V15.1481L14.0878 16.5197C13.969 16.5456 13.8583 16.6 13.7652 16.6783C13.6721 16.7565 13.5994 16.8562 13.5535 16.9688L10.5535 24.4688C10.5176 24.5581 10.4994 24.6537 10.5 24.75C10.5 26.9353 12.8006 27.75 14.25 27.75C15.6994 27.75 18 26.9353 18 24.75C18.0006 24.6537 17.9825 24.5581 17.9466 24.4688L15.2738 17.7909L20.25 16.6875V28.5H18.75C18.5511 28.5 18.3603 28.579 18.2197 28.7197C18.079 28.8603 18 29.0511 18 29.25C18 29.4489 18.079 29.6397 18.2197 29.7803C18.3603 29.921 18.5511 30 18.75 30H23.25C23.4489 30 23.6397 29.921 23.7803 29.7803C23.921 29.6397 24 29.4489 24 29.25C24 29.0511 23.921 28.8603 23.7803 28.7197C23.6397 28.579 23.4489 28.5 23.25 28.5H21.75V16.3519L26.5313 15.2906L24.0535 21.4688C24.0176 21.5581 23.9994 21.6537 24 21.75C24 23.9353 26.3006 24.75 27.75 24.75C29.1994 24.75 31.5 23.9353 31.5 21.75C31.5006 21.6537 31.4825 21.5581 31.4466 21.4688ZM16.4466 24.75H12.0581L14.25 19.2694L16.4466 24.75ZM25.5628 21.75L27.75 16.2694L29.9419 21.75H25.5628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_5059",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_24424_5059"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_5059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_5059",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActive);
export default __webpack_public_path__ + "static/media/salesActive.cacb158f71b23b5cfc650f8c09acab31.svg";
export { ForwardRef as ReactComponent };